// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PreviewModal_wrapper__2nW6Y","img":"PreviewModal_img__Z4GrW"};